module.exports = "<div class=\"center\">\n  <my-button my-label=\"$root.labels.wagon.statements.toggleTrains(displayTrains)\"\n    my-icon=\"$root.icons.display(displayTrains)\"\n    my-style=\"$root.styles.dark(displayTrains)\"\n    my-click=\"toggleDisplay()\">\n  </my-button>\n\n  <my-data-display my-data=\"myWagon.trains\"\n    my-nature=\"'train'\"\n    ng-show=\"displayTrains\"\n    enable-excel=\"true\"\n    enable-buttons=\"true\">\n  </my-data-display>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/entities/trains/wagon/directives/display/myWagonDisplayTrains.html
// module id = 1107
// module chunks = 0